export default "__VITE_PUBLIC_ASSET__036a0270__"